import {
    Worklist,
} from '@/Models/GenericWorklist/WorklistParams';

export const createDefaultWorklist = (): Worklist => {
    return {
        Params: {
            Pagination: {
                PageSize: 50,
                Offset: 0,
            },
            Sorting: [
                { Priority: 1, Column: 'ProcedureImplementationDate', Desc: true },
            ],
        },
        View: {
            Filters: [
                { ID: 'PatientFirstName', Visible: true },
                { ID: 'PatientLastName', Visible: true },
                { ID: 'SiteIDs', Visible: true },
                { ID: 'RoomsIDs', Visible: true },
                { ID: 'DateRange', Visible: true },
                { ID: 'OrderStatus', Visible: true },
                { ID: 'UrgencyIds', Visible: true },
                { ID: 'ModalityIDs', Visible: true },
                { ID: 'LabelsToIncludeIDs', Visible: true },
                { ID: 'DoB', Visible: false },
                { ID: 'ExternalID', Visible: false },
                { ID: 'NationalNumber', Visible: false },
                { ID: 'Language', Visible: false },
                { ID: 'PatientStatus', Visible: false },
                { ID: 'PatientOrigin', Visible: false },
                { ID: 'VisitNumber', Visible: false },
                { ID: 'UnitOfCare', Visible: false },
                { ID: 'LabelsToExcludeIDs', Visible: false },
                { ID: 'ProcedureStatus', Visible: false },
                { ID: 'OrderNumber', Visible: false },
                { ID: 'RequestingPhysicianFirstName', Visible: false },
                { ID: 'RequestingPhysicianLastName', Visible: false },
                { ID: 'AccessionNumber', Visible: false },
                { ID: 'Radiologists', Visible: false },
                { ID: 'Technicians', Visible: false },
                { ID: 'ProcedureDescription', Visible: false },
                { ID: 'ProcedureCodes', Visible: false },
                { ID: 'InvoiceStatuses', Visible: false },
                { ID: 'ReadyForInvoicing', Visible: false },
                { ID: 'ReportLocked', Visible: false },
                { ID: 'Justification', Visible: false },
                { ID: 'ReportAvailable', Visible: false },
                { ID: 'ReportStatuses', Visible: false },
                { ID: 'ReportModifiedBy', Visible: false },
                { ID: 'ReportCreatedDateRange', Visible: false },
                { ID: 'ReportModifiedDateRange', Visible: false },
                { ID: 'ReportParticipants', Visible: false },
                { ID: 'ReportParticipantType', Visible: false },
                { ID: 'Transcriptionists', Visible: false },
            ],
            Columns: [
                { ID: 'IsSelected', Visible: true },
                { ID: 'Patient', Visible: true },
                { ID: 'DoB', Visible: true },
                { ID: 'PatientStatus', Visible: true },
                { ID: 'ProcedureImplementationDate', Visible: true },
                { ID: 'Procedures', Visible: true },
                { ID: 'ProcedureStatus', Visible: true },
                { ID: 'RequestingPhysician', Visible: true },
                { ID: 'Remarks', Visible: true },
                { ID: 'Labels', Visible: true },
                { ID: 'Halls', Visible: false },
                { ID: 'OrderNumber', Visible: false },
                { ID: 'AccessionNumber', Visible: false },
                { ID: 'Radiologist', Visible: false },
                { ID: 'Technician', Visible: false },
                { ID: 'Sites', Visible: false },
                { ID: 'Age', Visible: false },
                { ID: 'ExternalID', Visible: false },
                { ID: 'NationalNumber', Visible: false },
                { ID: 'Language', Visible: false },
                { ID: 'PatientOrigin', Visible: false },
                { ID: 'VisitNumber', Visible: false },
                { ID: 'UnitOfCare', Visible: false },
                { ID: 'Urgencies', Visible: false },
                { ID: 'OrderStatus', Visible: false },
                { ID: 'OrderDateTimePrescription', Visible: false },
                { ID: 'InvoiceStatus', Visible: false },
                { ID: 'InvoiceAmount', Visible: false },
                { ID: 'ReadyForInvoicing', Visible: false },
                { ID: 'AdmissionDepartment', Visible: false },
                { ID: 'PatientLocation', Visible: false },
                { ID: 'Justification', Visible: false },
                { ID: 'ReportSupervisor', Visible: false },
                { ID: 'ReportReviewer', Visible: false },
                { ID: 'ReportValidatedBy', Visible: false },
                { ID: 'ReportTranscribedBy', Visible: false },
                { ID: 'ReportCreatedBy', Visible: false },
                { ID: 'ReportCreatedDateTime', Visible: false },
                { ID: 'ReportValidatedDateTime', Visible: false },
                { ID: 'ReportStatus', Visible: false },
            ],
        },
    };
};

export const WORKLIST_SETUP_DIALOG_FILTER_TAB = 'filter-settings-tab';
export const WORKLIST_SETUP_DIALOG_COLUMN_TAB = 'column-settings-tab';
